import { createSlider } from '@typeform/embed'
import '@typeform/embed/build/css/slider.css'

export default (formId) => ({
  init() {
    const { toggle } = createSlider(formId)
    this.open = toggle
  },
})
